/* eslint-disable max-len */
import React from 'react';

interface ISupportChatProps {
    color?: string;
}

const SupportChat: React.FC<ISupportChatProps> = ({color = '#13ABAC'}) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="16" height="16" rx="8" fill={color}/>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 6C4 4.89543 4.89543 4 6 4H10C11.1046 4 12 4.89543 12 6V8C12 9.10457 11.1046 10 10 10H7.41421L5.70711 11.7071C5.42111 11.9931 5 11.7899 5 11.4142V9.90325C4.4174 9.70907 4 9.15851 4 8.5V6Z"
                fill="white"
            />
        </svg>
    );
};

export default SupportChat;
